import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.SetStatusUnrestricted.IRequest;
type Response = Api.Core.Contract.SetStatusUnrestricted.IResponse;
type Headers = Api.Core.Contract.SetStatusUnrestricted.IHeaders;
const url = '/api/Sales/Contract/SetStatusUnrestricted/:contractId';
export default async function contractSetStatusUnrestrictedApi(
  contractId: number,
  body: Request
): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url: createPathFromRoute(url, { contractId }),
    body: body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
